import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import AppRoutes from "./routes/AppRoutes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data stays fresh for 5 minutes
      gcTime: 1000 * 60 * 60 * 2, // Cache persists for 2 hours
      refetchOnWindowFocus: true, // Refetch when tab becomes active
      refetchOnReconnect: 'always', // Refetch on network reconnection
      refetchOnMount: 'always', // Refetch when component mounts
      retry: 3, // Retry failed requests 3 times
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
      networkMode: 'always', // Continue trying requests even if offline
      placeholderData: 'keep', // Keep showing old data while fetching new data (previously keepPreviousData)
    },
    mutations: {
      retry: 2,
      networkMode: 'always',
    },
  },
});

// Enable background fetching
queryClient.setDefaultOptions({
  queries: {
    refetchInterval: (query) => {
      // Refetch frequently accessed data every 30 seconds
      if (query.queryKey.includes('matches') || query.queryKey.includes('notifications')) {
        return 1000 * 30;
      }
      // Refetch other data every 5 minutes
      return 1000 * 60 * 5;
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <TooltipProvider>
          <div className="min-h-screen bg-background">
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </div>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;